export const environment = {
    production: false,
    apiUrl: 'https://workinc-api-dev.vtserver.eu',
    appVersion: '1.0.2'
};
